<template>
  <div>
    <div class="text-xl font-black py-2 mt-8">1. Performance Review</div>
    <div class="font-black py-2">Business Forecast</div>
    <div class="mb-4">
      The following data is automatically pulled in from 'Land Registry' for the combined licensed areas.
    </div>
    <office-land-registry-data :officeId="review.office_id" :reviewId="review.id" />
    <!-- Waiting for Aaron -->
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
// import OfficeLandRegistryData from '../../../components/land-registry-data/OfficeLandRegistryData'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart'],
  data () {
    return {
      form: this.value
    }
  },
  mounted () {
  }
}
</script>
